import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { CombinedCalendarComponent } from './combined-calendar/combined-calendar.component';
import { DeliveryJobsListComponent } from './my-jobs-tile/delivery-jobs-list/delivery-jobs-list.component';
import { WorkshopJobsListComponent } from './my-jobs-tile/workshop-jobs-list/workshop-jobs-list.component';

export const dashboardRoutes: Routes = [
  { path: '', component: DashboardComponent },
  {
    path: 'combined-calendar',
    component: CombinedCalendarComponent,
    title: 'Combined Calendar'
  },
  {
    path: 'my-delivery-jobs',
    component: DeliveryJobsListComponent,
    title: 'My Transport Jobs'
  },
  {
    path: 'my-workshop-jobs',
    component: WorkshopJobsListComponent,
    title: 'My Workshop Jobs'
  }
];
